// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bj-0";
export var orangeButton = "_bj-1";